import Vue from 'vue'
import VueBus from 'vue-bus'
Vue.use(VueBus)